import { Fragment } from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
import moment from "moment";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    padding: 20,
  },
  section: {
    marginBottom: 10,
  },
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 10,
    marginTop: 10,
  },
  title: {
    fontSize: 12,
    fontFamily: "Times-Bold",
  },
  spacing: {
    marginTop: 10,
  },
  subtitle: {
    fontSize: 10,
  },
  table: {
    display: "flex",
    flexDirection: "column",
    border: "1px solid black",
    marginTop: 8,
    borderRight: 0,
    borderBottom: 0,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableCol: {
    flex: 1,
    borderRight: "1px solid black",
    borderBottom: "1px solid black",
    padding: 3,
    fontSize: 8,
  },
  tableSpacing: {
    flex: 1,
    borderRight: "1px solid black",
    borderBottom: "1px solid black",
    padding: 3,
    maxWidth: 15,
  },
  tableColHead: {
    fontFamily: "Times-Bold",
    flex: 1,
    borderRight: "1px solid black",
    borderBottom: "1px solid black",
    padding: 3,
    fontSize: 10,
  },
  boldText: {
    fontFamily: "Times-Bold",
  },
  tableHeader: {
    backgroundColor: "#d3d3d3",
    fontWeight: "bold",
  },
});

const TrialDogResults = ({ data }) => {
  const renderTable = (subItem, subIndex) => (
    <View key={subIndex} style={styles.table}>
      <View style={[styles.tableRow, styles.tableHeader]}>
        <Text style={styles.tableColHead}>{subIndex + 1}. {subItem.search}</Text>
        <Text style={styles.tableColHead}></Text>
        <Text style={styles.tableSpacing} />
        <Text style={styles.tableColHead}>
          {subItem.search.includes("Pro") ? "Pro" : "Standard"}
        </Text>
        <Text style={styles.tableColHead}></Text>
      </View>
      <View style={styles.tableRow}>
        <Text style={styles.tableCol}>Hides Set</Text>
        <Text style={styles.tableCol}>{subItem.hidesSet}</Text>
        <Text style={styles.tableSpacing} />
        <Text style={styles.tableCol}>Time Limit</Text>
        <Text style={styles.tableCol}>{subItem.timeLimit}</Text>
      </View>
      <View style={styles.tableRow}>
        <Text style={styles.tableCol}>Hides Found</Text>
        <Text style={styles.tableCol}>{subItem.hidesFound}</Text>
        <Text style={styles.tableSpacing} />
        <Text style={styles.tableCol}>Your Time</Text>
        <Text style={styles.tableCol}>{subItem.time}</Text>
      </View>
      <View style={styles.tableRow}>
        <Text style={styles.tableCol}>Q/NQ</Text>
        <Text style={styles.tableCol}>{subItem.qNq}</Text>
        <Text style={styles.tableSpacing} />
        <Text style={styles.tableCol}>NQ Reason</Text>
        <Text style={styles.tableCol}>{subItem.ngReason}</Text>
      </View>
      <View style={styles.tableRow}>
        <Text style={styles.tableCol}>Faults</Text>
        <Text style={styles.tableCol}>{subItem.faults}</Text>
        <Text style={styles.tableSpacing} />
        <Text style={styles.tableCol}>Fault Reason</Text>
        <Text style={styles.tableCol}>{subItem.faultReason}</Text>
      </View>
      <View style={styles.tableRow}>
        <Text style={styles.tableCol}>Points</Text>
        <Text style={styles.tableCol}>{subItem.points}</Text>
        <Text style={styles.tableSpacing} />
        <Text style={styles.tableCol}>Place</Text>
        <Text style={styles.tableCol}>{subItem.place}</Text>
      </View>
      <View style={styles.tableRow}>
        <Text style={styles.tableCol}>
          Judge Notes: &nbsp;
          <Text style={styles.tableCol}>{subItem.judgeNotes}</Text>
        </Text>
      </View>
    </View>
  );

  return (
    <Document>
      {data.result.map((item, index) => {
        const nonSITSearches = item.data.filter(d => !d.search.toUpperCase().includes("SIT"));
        const sitSearches = item.data.filter(d => d.search.toUpperCase().includes("SIT"));
        return (
          <Fragment key={index}>
            {nonSITSearches.length > 0 && (
              <Page size="A4" style={styles.page}>
                <View style={styles.section}>
                  <View style={styles.header}>
                    <Text style={styles.title}>{data.trialName}</Text>
                    <Text style={styles.title}>{moment.utc(data.date).format("MM/DD/YYYY")}</Text>
                  </View>
                  <Text style={styles.title}>
                    Trial Results for {item.memberName} & {item.dogName}
                  </Text>
                  {item.awards && (
                    <Text style={[styles.title, styles.spacing]}>
                      Awards: &nbsp;
                      <Text style={styles.subtitle}>{item.awards}</Text>
                    </Text>
                  )}
                  {nonSITSearches.map((subItem, subIndex) =>
                    renderTable(subItem, subIndex)
                  )}
                </View>
              </Page>
            )}

            {sitSearches.length > 0 && (
              <Page size="A4" style={styles.page}>
                <View style={styles.section}>
                  <View style={styles.header}>
                    <Text style={styles.title}>{data.trialName}</Text>
                    <Text style={styles.title}>{moment.utc(data.date).format("MM/DD/YYYY")}</Text>
                  </View>
                  <Text style={styles.title}>
                    Trial Results for {item.memberName} & {item.dogName}
                  </Text>
                  {item.awards && (
                    <Text style={[styles.title, styles.spacing]}>
                      Awards: &nbsp;
                      <Text style={styles.subtitle}>{item.awards}</Text>
                    </Text>
                  )}
                  {sitSearches.map((subItem, subIndex) =>
                    renderTable(subItem, subIndex)
                  )}
                </View>
              </Page>
            )}
          </Fragment>
        );
      })}
    </Document>
  );
};

export default TrialDogResults;
